import React, { useEffect, useMemo, useState } from "react";
import { useLocale } from "../../locales/useLocale.js";

/** Shows plugin's lang.json with per-locale previews and quick search. */
export default function LanguagePack() {
  const { locale, setLocale, availableLocales } = useLocale();
  const [pack, setPack] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetch("/lang.json").then((r) => r.json()).then((j) => {
      if (!cancelled) setPack(j);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const entries = useMemo(() => {
    if (!pack?.langId) return [];
    const list = Object.entries(pack.langId);
    const needle = q.trim().toLowerCase();
    if (!needle) return list.slice(0, 80);
    return list
      .filter(([id, v]) => {
        if (id.includes(needle)) return true;
        const vals = v?.values ?? {};
        return Object.values(vals).some((s) => String(s).toLowerCase().includes(needle));
      })
      .slice(0, 80);
  }, [pack, q]);

  return (
    <div className="card">
      <div className="card__title">
        Language pack
        <span className="badge">{availableLocales.length} locales</span>
      </div>
      <div className="row" style={{ marginBottom: 10 }}>
        <select value={locale} onChange={(e) => setLocale(e.target.value)} style={input}>
          {availableLocales.map((l) => (
            <option key={l} value={l}>
              {l.toUpperCase()}
            </option>
          ))}
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by id or text…" style={{ ...input, flex: 1 }} />
      </div>
      {!pack && <span className="loader" />}
      {pack && (
        <div style={{ maxHeight: 280, overflow: "auto" }}>
          {entries.map(([id, v]) => (
            <div key={id} style={row}>
              <span className="muted small" style={{ width: 60, fontFamily: "monospace" }}>#{id}</span>
              <span style={{ flex: 1 }}>{v.values?.[locale] ?? v.values?.en ?? "—"}</span>
            </div>
          ))}
          {entries.length === 0 && <div className="placeholder-panel">Nothing matches “{q}”.</div>}
        </div>
      )}
    </div>
  );
}
const input = {
  padding: "7px 10px",
  border: "1px solid var(--color-border-input)",
  borderRadius: 8,
  fontSize: 13,
  background: "#fff",
};
const row = {
  display: "flex",
  gap: 10,
  padding: "6px 4px",
  borderBottom: "1px solid var(--color-border)",
  fontSize: 13,
};
